export default __webpack_public_path__ + "static/media/6dbfb4f5ef2cfe6162a8879d5a969507.791172b9.svg";